import React, { useState, useEffect } from "react";
import logo from "./images/favicon.png";
import logo1 from "./images/logo.png";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./Constants";

const Navbar = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
const [error, setError] = useState(null); // To handle errors
  /* ==============================
     COLLAPSE SIDEBAR ON LOAD
  ============================== */
  useEffect(() => {
    const body = document.querySelector("body");

    // 👇 Make sidebar collapsed by default
    body.classList.add("sidebar-icon-only");
    setSidebarOpen(false);
  }, []);

  useEffect(() => {
  const token = localStorage.getItem("authToken");

  // If token not available → logout
  if (!token) {
    localStorage.clear();
    navigate("/");
  }
}, [navigate]);

  /* ==============================
     FETCH PROFILE
  ============================== */
 useEffect(() => {
  const token = localStorage.getItem("authToken");

  const fetchProfile = async () => {
    try {
      const response = await fetch(`${BASE_URL}profile`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      // ✅ TOKEN INVALID CHECK
      if (!response.ok || data?.error === "Invalid token") {
        localStorage.removeItem("authToken"); // optional cleanup
        navigate("/"); // redirect to login
        return;
      }

      console.log("Fetched Profile Data:", data);
      setUser(data);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchProfile();
}, [navigate]);

  /* ==============================
     LOGOUT
  ============================== */
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("authToken");

      await fetch(`${BASE_URL}logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  /* ==============================
     TOGGLE SIDEBAR
  ============================== */
  const toggleSidebar = () => {
    const body = document.querySelector("body");

    if (isSidebarOpen) {
      body.classList.add("sidebar-icon-only");
      setSidebarOpen(false);
    } else {
      body.classList.remove("sidebar-icon-only");
      setSidebarOpen(true);
    }
  };

  if (loading) return null;

  return (
    <div className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      
      {/* ================= LOGO ================= */}
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <a className="navbar-brand brand-logo me-4" href="/">
          <img src={logo1} alt="logo" style={{ height: "50px" }} />
        </a>

        <a className="navbar-brand brand-logo-mini" href="/">
          <img src={logo} alt="logo" />
        </a>
      </div>

      {/* ================= RIGHT MENU ================= */}
      <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        
        {/* Desktop Toggle */}
        <button
          className="navbar-toggler align-self-center"
          type="button"
          onClick={toggleSidebar}
        >
          <span className="icon-menu"></span>
        </button>

        {/* Right Side Menu */}
        <ul className="navbar-nav navbar-nav-right">
          
          {/* Notifications */}
          <li className="nav-item dropdown">
            <a
              className="nav-link count-indicator dropdown-toggle"
              href="#"
              data-bs-toggle="dropdown"
            >
              {/* <i className="icon-bell mx-0"></i> */}
            </a>
          </li>

          {/* Profile */}
          <li className="nav-item nav-profile dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              data-bs-toggle="dropdown"
            >
              <img
                src={logo}
                alt="profile"
                style={{ width: "40px", borderRadius: "50%" }}
              />
            </a>

            <div className="dropdown-menu dropdown-menu-right navbar-dropdown">
              <button
                className="dropdown-item"
                onClick={handleLogout}
              >
                <i className="ti-power-off text-primary me-2"></i>
                Logout
              </button>
            </div>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default Navbar;
